module.exports = __webpack_public_path__ + "assets/projects/berlinfuchs/project-preview.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/projects/berlinfuchs/project-preview.jpg
// module id = 9
// module chunks = 0